export const ProjectsData = [
    {
        name: 'Car Manufacturer',
        img: 'https://i.ibb.co/mqRhVmG/carM.png',
        technology: ['Firebase', "React", "NodeJs", "ExpressJS", "Mongodb", "Tailwind"],
        link: {
            live: 'https://car-manufacturer-df280.web.app/',
            github: 'https://github.com/SRAKIB17/manufacturer-website-client-side-SRAKIB17',
            githubServer: 'https://github.com/SRAKIB17/manufacturer-website-server-side-SRAKIB17'
        },
        html: ``,
        // new: true
    },

    {
        name: 'URL Shortener',
        img: 'https://i.ibb.co/2vD9sxN/url.png',
        technology: ['Firebase', "React", "NodeJs", "ExpressJS", "Mongodb", "Tailwind"],
        link: {
            live: 'https://ur7.netlify.app/',
            github: 'https://github.com/SRAKIB17/url-shortener-client',
            githubServer: 'https://github.com/SRAKIB17/url-shortener-server'
        },
        html: ``,
        // new: true,
    },

    {
        name: 'SVG PRO',
        img: 'https://i.ibb.co/m91bXtn/screencapture-svg-pro-vercel-app-svg-1-2022-08-23-22-44-36.png',
        technology: ['NextJS', "NodeJs", "Tailwind"],
        link: {
            live: 'https://svg-pro.vercel.app/',
            // github: 'https://github.com/SRAKIB17/manufacturer-website-client-side-SRAKIB17',
            // githubServer: 'https://github.com/SRAKIB17/manufacturer-website-server-side-SRAKIB17'
        },
        html: ``,
        // new: 'new'
    },
    {
        name: 'ProgLearn Blog',
        img: 'https://i.ibb.co/TBfv92k/fff.png',
        technology: ['NextJS', "NodeJs", "Tailwind","Crypto authentication"],
        link: {
            live: 'https://prog-learn.vercel.app/',
            // github: 'https://github.com/SRAKIB17/manufacturer-website-client-side-SRAKIB17',
            // githubServer: 'https://github.com/SRAKIB17/manufacturer-website-server-side-SRAKIB17'
        },
        html: ``,
        // new: 'new'
    },
    {
        name: 'TOURIST TRAVEL',
        img: 'https://i.ibb.co/93cgyQL/screencapture-tourist-travel-guide-b4ac3-web-app-2022-08-23-23-05-32.png',
        technology: ['HTML', "REACT", "Bootstrap","CSS"],
        link: {
            live: 'https://tourist-travel-guide-b4ac3.web.app/',
            github: 'https://github.com/SRAKIB17/tourist-travel-guide-react',
            // githubServer: 'https://github.com/SRAKIB17/manufacturer-website-server-side-SRAKIB17'
        },
        html: ``,
        // new: 'new'
    },
    {
        name: 'GROCERY WAREHOUSE',
        img: 'https://i.ibb.co/ZcQwpqH/screencapture-grocery-warehouse-e95eb-web-app-2022-08-23-23-09-04.png',
        technology: ['HTML', "REACT", "NodeJs","CSS","Express", "Mongodb"],
        link: {
            live: 'https://grocery-warehouse-e95eb.web.app/home',
            github: 'https://github.com/SRAKIB17/grocery-warehouse-client-side',
            githubServer: 'https://github.com/SRAKIB17/Grocery-warehouse-server-side'
        },
        html: ``,
        // new: 'new'
    },

]
